import React, { useEffect, useRef } from 'react';
import { scrollOneScreen, handleSlider, throttledHandleSlider } from '../../../product/components/SimilarItems/helpers';
import { useMediaQuery } from '@material-ui/core';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';

import './styles.scss';
import { RecommendationServiceNode } from '../../../product/components/SimilarItems/RecommendationServiceCarousel/RecommendationServiceTypes';
import PGWCarouselItem from './PGWCarouselItem';

const CrossSellCarousel = ({ data, blockTitle, handle }: IProducts) => {
  const { recommendedProductsByProductId: productsRaw } = data;
  const carousel: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
  const productSlider: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });
  const products = productsRaw.filter((product) => product.onlineStoreUrl && product.handle !== handle).slice(0, 10);

  useEffect(() => {
    const currentSlider = productSlider.current;
    if (currentSlider && !isMobile) {
      handleSlider(carousel);
      currentSlider.addEventListener('scroll', () => {
        throttledHandleSlider(carousel);
      });
      return () => {
        if (currentSlider)
          currentSlider?.removeEventListener('scroll', () => {
            throttledHandleSlider(carousel);
          });
      };
    }
  }, [isMobile]);

  return (
    <div
      ref={carousel}
      style={products.length < 1 ? { display: 'none' } : {}}
      className="container product-carousel-container crosssell-product-container position-relative product-carousel"
    >
      <div className="row no-gutters">
        <div className="col-12">
          <h4 className="similar-items__title h4 semibold uppercase">{blockTitle ? blockTitle : 'pairs great with'}</h4>
        </div>
      </div>
      <div
        className="arrow--left insta-arrow--left"
        role="button"
        onClick={() => {
          if (productSlider) scrollOneScreen('left', productSlider);
        }}
      />
      <div
        className="arrow--right insta-arrow--right"
        role="button"
        onClick={() => {
          if (productSlider) scrollOneScreen('right', productSlider);
        }}
      />

      <div ref={productSlider} className="row no-gutters product-carousel--pdp crosssell-product--pdp">
        {products.map((product) => (
          <PGWCarouselItem product={product} isMobile={isMobile} key={product.handle} />
        ))}
      </div>
    </div>
  );
};

export default CrossSellCarousel;

interface IProducts {
  data: { recommendedProductsByProductId: RecommendationServiceNode[] };
  blockTitle?: string;
  handle?: string;
}
